import "./CurrentQuoteComponent.scss";
import template from "./CurrentQuoteComponent.html";
import {IComponentOptions, IRootElementService} from "angular";
import {QuoteViewModel} from "../../models/QuoteViewModel";
import {ComponentCallback} from "../../../types/AngularJS";

export const CurrentQuote = "tfCurrentQuote";

export function currentQuote(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<quote",
            onBidClicked: "&",
            onAskClicked: "&"
        },
        controllerAs: "ctrl",
        controller: CurrentQuoteComponentController
    };
}

export class CurrentQuoteComponentController {
    /** @input */
    public readonly model: QuoteViewModel;

    /** @output */
    public readonly onBidClicked: ComponentCallback;

    /** @output */
    public readonly onAskClicked: ComponentCallback;

    public readonly hasBidClick: boolean;
    public readonly hasAskClick: boolean;

    /** @ngInject */
    public constructor($element: IRootElementService) {
        this.hasBidClick = $element.attr("on-bid-clicked") != null;
        this.hasAskClick = $element.attr("on-ask-clicked") != null;
    }
}
